import { render, staticRenderFns } from "./TopSales.vue?vue&type=template&id=52e862e2"
import script from "./TopSales.vue?vue&type=script&lang=js"
export * from "./TopSales.vue?vue&type=script&lang=js"
import style0 from "./TopSales.vue?vue&type=style&index=0&id=52e862e2&prod&lang=css"
import style1 from "./TopSales.vue?vue&type=style&index=1&id=52e862e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports